import script from "./StudentInformationForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudentInformationForm.vue?vue&type=script&setup=true&lang=ts"

import "./StudentInformationForm.vue?vue&type=style&index=0&id=506ff8e8&scoped=true&lang=css"
import "@/styles/snackbar.css?vue&type=style&index=1&id=506ff8e8&scoped=true&lang=css"
import "@/styles/student/student-information-form.css?vue&type=style&index=2&id=506ff8e8&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-506ff8e8"]])

export default __exports__